import PreviewIcon from '@mui/icons-material/Preview';
import { Button, ButtonProps, styled } from '@mui/material';
import { FC } from 'react';

const StyledButton = styled(Button)({
	textTransform: 'none',
	textAlign: 'left',
	justifyContent: 'space-between',
});

export const DashboardTopButton: FC<ButtonProps> = props => {
	return <StyledButton fullWidth color="inherit" variant="outlined" endIcon={<PreviewIcon />} {...props} />;
};
